import React from 'react';
import {Container, Grid} from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import {bannerData} from '../../values';
import {useStyles} from './styles';
const Banner = ({title}) => {
    const classes = useStyles()
    const history = useHistory()
    return (
        <div>
            <div style={{height:80}}>
                <img alt="Logo Rayas" src={bannerData.image} style={{position:'absolute', left:50, width:80, top:12, cursor:'pointer'}}  onClick={() => history.push('/')} />
                <div style={{borderRadius:7, cursor:'pointer', width:180, background:'black', position:'absolute', right:70, top:20}}>
                    <div style={{display:'flex', alignItems:'center',paddingTop:3,paddingBottom:3}}>
                        <img alt="Icon Apple" src={bannerData.icon} style={{width:30, paddingLeft:10}} />
                        <label style={{paddingLeft:10, fontSize:25, fontWeight:600, cursor:'pointer', color:'white', fontFamily:'Book',}}>{bannerData.button}</label>
                    </div>
                </div>
            </div>
            <div className={classes.banner}>
                <Container maxWidth='xl'>
                    <p className={classes.titleBanner}>{title}</p>
                </Container>
            </div>
        </div>
    );
};

export default Banner;